import {classNames, layout, Slideshow} from "@variocube/cube-ui";
import * as React from "react";
import {stylesheet} from "typestyle";
import pickup from "./pickup.svg";
import signup from "./signup.svg";
import storage from "./storage.svg";
import {useLocalization} from "../../i18n";


export function HowItWorks() {
    const {t} = useLocalization();
    return (
        <Slideshow>
            <div className={classNames(layout.horizontal, styles.slide)}>
                <div className={styles.halfSlide}>
                    <img className={styles.image} src={signup}/>
                </div>
                <div className={classNames(styles.halfSlide, styles.text)}>
                    <Step number="1" text={t("HowItWorks1")} />
                    <Step number="2" text={t("HowItWorks2")} />
                </div>
            </div>
            <div className={classNames(layout.horizontal, styles.slide)}>
                <div className={styles.halfSlide}>
                    <img className={styles.image} src={storage}/>
                </div>
                <div className={classNames(styles.halfSlide, styles.text)}>
                    <Step number="3" text={t("HowItWorks3")} />
                    <Step number="4" text={t("HowItWorks4")} />
                </div>
            </div>
            <div className={classNames(layout.horizontal, styles.slide)}>
                <div className={styles.halfSlide}>
                    <img className={styles.image} src={pickup}/>
                </div>
                <div className={classNames(styles.halfSlide, styles.text)}>
                    <Step number="5" text={t("HowItWorks5")} />
                    <Step number="6" text={t("HowItWorks6")} />
                </div>
            </div>
        </Slideshow>
    )
}

function Step({number, text}: {number: string; text:string}) {
    return (
        <div className={classNames(layout.horizontal, styles.step)}>
            <div className={styles.stepNumber}>
                {number}
            </div>
            <div className={styles.stepText}>
                {text}
            </div>
        </div>
    )
}

const styles = stylesheet({
    slide: {
        height: "100%"
    },
    halfSlide: {
        width: "50%"
    },
    image: {
        maxHeight: "90%",
        width: "auto",
        display: "block",
    },
    text: {
        marginTop: "2em",
    },
    step: {
        marginBottom: "1em",
        alignItems: "flex-start",
    },
    stepNumber: {
        color: "var(--color-primary)",
        fontWeight: "bold",
        fontSize: "3em",
        marginRight: "0.5rem"
    },
    stepText: {
        marginTop: "0.5em",
    },
});
